import createApp from './main-ssr'
import store from './store/100roxasavenue'

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

createApp({ ssr: false })['app'].$mount('#app')
